export type MenuRefreshStatus = 'up_to_date' | 'updating' | 'delayed' | 'unavailable'

export function menuRefreshLabel(status: MenuRefreshStatus): string {
  if (status === 'up_to_date') return 'Up to date'
  if (status === 'updating') return 'Updating'
  if (status === 'delayed') return 'Delayed'
  return 'Temporarily unavailable'
}

export function menuRefreshHealth(status: MenuRefreshStatus): 'ok' | 'warn' | 'fail' {
  if (status === 'up_to_date') return 'ok'
  if (status === 'updating' || status === 'delayed') return 'warn'
  return 'fail'
}

export function formatMenuUpdatedAt(value: string | null, now = new Date()): string {
  if (!value) return 'Not updated yet'
  const timestamp = new Date(value)
  const ageMs = now.getTime() - timestamp.getTime()
  if (!Number.isFinite(ageMs)) return 'Update time unavailable'
  const minutes = Math.max(0, Math.floor(ageMs / 60_000))
  if (minutes < 2) return 'Updated just now'
  if (minutes < 60) return `Updated ${minutes} min ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `Updated ${hours} hr ago`
  const days = Math.floor(hours / 24)
  return `Updated ${days} day${days === 1 ? '' : 's'} ago`
}
